const H6 = (props) => {
  return (
    <h6
      style={{
        color: "#303030",
        fontSize: "2.4rem",
        lineHeight: "1.3",
        fontWeight: "500",
      }}
    >
      {props.text}
    </h6>
  );
};

export default H6;
